<template>
	<inertia-head title="Video Library" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Video Library</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Take your financial knowledge to the next level with Gold Call! Our weekly live sessions offer an engaging way to learn from the pros. Plus, get access to recordings of past events so you can review and stay up-to-date on the latest trends and strategies. Unlock your potential with Gold Call and invest in yourself today!
					</h2>
				</div>
			</div>
		</div>
	</div>


	<modal ref="modal" size="modal-xl">
		<template #title>
			{{selectedVideo.title}}
		</template>
		<template #body>
			<div class="mb-4">
				<VimeoIframe :videoId="selectedVideo.video_id" />
			</div>
		</template>
	</modal>

	<div class="content">
		<div class="block block-rounded">
			<div class="block-content block-content-full border-bottom border-5 border-warning">
				<div role="tablist">
					<button type="button" id="tab_live" @click="selected_tab='live'" class="btn btn-outline-warning rounded-0 ms-2 px-3 active" role="tab" data-bs-toggle="tab" data-bs-target="#btabs-animated-fade-live" aria-controls="btabs-animated-fade-live" aria-selected="true"><i class="fa fa-video me-1"></i>TRC LIVE</button>
					<button type="button" id="tab_category" @click="getCategory" class="btn btn-outline-warning rounded-0 ms-2 px-3" role="tab" data-bs-toggle="tab" data-bs-target="#btabs-animated-fade-library" aria-controls="btabs-animated-fade-library"><i class="fa fa-book-open me-1"></i>Library</button>
				</div>
			</div>
			<div class="tab-content">
				<div id="btabs-animated-fade-live" class="tab-pane block-content block-content-full fade active show" role="tabpanel" aria-labelledby="btabs-animated-fade-live">
					<div v-if="$page.props.user.current_rank=='SILVER'" class="p-5 text-center">
						<p class="h1 text-center m-0 text-danger">Please upgrade to GOLD or HIGHER membership level to access the live video</p>
						<inertia-link href="/member/upgrade" class="btn btn-danger btn-lg mt-5"><i class="fa fa-arrow-circle-up me-2"></i>Upgrade Here</inertia-link>
					</div>
					<div v-else>
						<div v-if="liveVideo.length>0" class="row">
							<div class="col-md-8">
								<div v-if="countdown_time_left<=86400" class="mb-3 bg-danger">
									<div v-if="!countdown_done" class="mb-0 py-2 text-center text-white">
				                      	<p class="m-0 mb-3 h4">{{liveVideo[0].start_display}}</p>
				                      	<p class="m-0 mb-3 h3">Time left before we go LIVE</p>
				                      	<div id="countdown_display" class="fw-bold m-0 display-4">
				                      		{{countdown_display}}
				                      	</div>
				                    </div>
								</div>
								<LiveVideoIframe :video-id="live_vimeo_id" />
							</div>
							<div class="col-md-4">
								<iframe :src="'https://vimeo.com/event/'+live_vimeo_id+'/chat/'" width="100%" height="500" frameborder="0"></iframe>
							</div>
						</div>

						<div class="row mt-5">
							<div  class="md-12">
								<h1>Live Schedules</h1>
								<hr/>
								<div class="table-responsive">
									<table class="table">
										<thead>
											<tr>
												<th>Date</th>
												<th>Topic</th>
												<th>Hosted By</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(sched, s_index) in liveSchedules">
												<td>{{sched.start_display}}</td>
												<td>{{sched.title}}</td>
												<td>{{sched.host_by}}</td>
											</tr>
											<tr v-if="liveSchedules.length==0">
												<td colspan="3"><h3 class="text-center text-danger mt-4">No Schedule Yet</h3></td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div id="btabs-animated-fade-library" class="tab-pane fade" role="tabpanel" aria-labelledby="btabs-animated-fade-library">
					<div class="border-bottom border-4 border-primary shadow">
						<div class="featured-videos-bg p-4">
							<h1 class="text-white">Featured Videos</h1>
							<div class="row">
								<div v-for="(featured,f_index) in featuredVideos" :class="{'col-md-12':featuredVideos.length==1,'col-md-6':featuredVideos.length==2,'col-md-4':featuredVideos.length>=3,}">
									<a class="block shadow-none bg-image" style="background-size: cover;background-position: center center;" :style="{'background-image': 'url('+featured.video_img_url+')'}" href="javascript:void(0)">
						                <div class="block-content block-content-full bg-black-50 border border-primary">
						                  	<div class="pt-7">
							                    <p class="h4 text-white fw-bold mb-3 video-title">
							                      	{{featured.title}}
							                      	<div><span class="badge bg-warning fs-xs">{{getCategoryTitle(featured.category)}}</span></div>
							                    </p>
							                    <p class="text-white-75 fw-medium fs-xs mb-0">
							                      	<span class="me-2">
							                        	<i class="far fa-clock opacity-75 me-1"></i> {{featured.video_mins}}
							                      	</span>
							                      	<span>
							                        	<i class="far fa-calendar-alt opacity-75 me-1"></i> {{featured.date_display}}
							                      	</span>
							                    </p>
							                    <p class="m-0 mt-2 p-0 text-center">
							                    	<button @click="selectVideo(f_index,'featured')" type="button" class="btn btn-outline-primary btn-sm fs-xs"><i class="fa fa-video me-1"></i>Watch Video</button>
							                    </p>
						                  	</div>
						                </div>
					              	</a>
								</div>
								<div v-if="featuredVideos.length==0">
									<h1 class="text-center text-white mt-5">No Featured Videos Found</h1>
								</div>
							</div>
						</div>
					</div>
					
					<div class="block-content block-content-full mt-5">
						<div class="input-group mb-3 border-bottom pb-2">
							<span class="input-group-text">Category</span>
							<select v-model="selected_category" class="form-control">
								<option value="">ALL</option>
								<optgroup v-for="(category,index) in categories()" :label="index">
									<option
										v-for="(cat,c_index) in category"
										:key="c_index"
										:value="c_index"
									>
										{{ cat }}
									</option>
								</optgroup>
							</select>
						</div>
						<div class="my-3" role="tablist">
							<button type="button" @click="filterByDate('all')" id="btn_show_all" role="tab" data-bs-toggle="tab" class="btn btn-outline-info me-2 mb-2 active"><i class="fa fa-filter me-1"></i>Show All</button>
							<button type="button" @click="filterByDate('today')" id="btn_filter_today" role="tab" data-bs-toggle="tab" class="btn btn-outline-info me-2 mb-2"><i class="fa fa-calendar me-1"></i>Today</button>
							<button type="button" @click="filterByDate('yesterday')" id="btn_filter_yesterday" role="tab" data-bs-toggle="tab" class="btn btn-outline-info me-2 mb-2"><i class="fa fa-calendar-check me-1"></i>Yesterday</button>
							<!-- <button type="button" @click="filterByDate('this_week')" id="btn_filter_this_week" role="tab" data-bs-toggle="tab" class="btn btn-outline-info me-2 mb-2"><i class="fa fa-calendar-plus me-1"></i>This Week</button>
							<button type="button" @click="filterByDate('next_week')" id="btn_filter_next_week" role="tab" data-bs-toggle="tab" class="btn btn-outline-info me-2 mb-2"><i class="fa fa-calendar-times me-1"></i>Next Week</button> -->
							<button type="button" @click="filterByDate('last_week')" id="btn_filter_last_week" role="tab" data-bs-toggle="tab" class="btn btn-outline-info mb-2"><i class="fa fa-calendar-alt me-1"></i>Last Week</button>
						</div>
						<p v-if="filter_date!='all'" class="fw-bold mt-5 mb-0">Search Results For : {{filter_date.toUpperCase().split("_").join(" ")}}</p>
						<div v-if="videoLibraries.data.length==0" class="mt-5">
							<h1 class="text-center text-danger">No Video Found</h1>
						</div>
						<div v-else class="mt-5">
							<div v-if="checkVideoDeniedAccess($page.props.user.current_rank)" class="p-4">
								<h3 class="text-center mt-5 text-danger">Please upgrade to higher membership level to access the videos</h3>
							</div>
							<div v-else class="block" :class="{'block-mode-loading':searching_process==true}">
								<pagination :collections="videoLibraries" />
								<div class="row">
									<div v-for="(video,v_index) in videoLibraries.data" :class="{'col-md-12':videoLibraries.data.length==1,'col-md-6':videoLibraries.data.length==2,'col-md-4':videoLibraries.data.length>=3}">
										<a class="block shadow-none border-start border-5 bg-image"  style="background-size: cover;background-position: center center;" :style="{'background-image': 'url('+video.video_img_url+')'}" href="javascript:void(0)"
											:class="['border-primary','border-success','border-warning','border-info','border-danger'][Math.floor(Math.random() * 5)]"
										>
							                <div class="p-4 bg-black-50">
							                  <div class="pt-7">
							                    <p class="h5 text-white fw-bold mb-3 video-title">
							                      {{video.title}}
							                      <div><span class="badge bg-warning fs-xs">{{getCategoryTitle(video.category)}}</span></div>
							                    </p>
							                    <p class="text-white-75 fw-medium fs-xs mb-0">
							                      <span class="me-2">
							                        <i class="far fa-clock opacity-75 me-1"></i> {{video.video_mins}}
							                      </span>
							                      <span>
							                        <i class="far fa-calendar-alt opacity-75 me-1"></i> {{video.date_display}}
							                      </span>
							                    </p>
							                    <p class="m-0 mt-2 p-0 text-center">
							                    	<button @click="selectVideo(v_index,'category')" type="button" class="btn btn-outline-primary btn-sm fs-xs"><i class="fa fa-video me-1"></i>Watch Video</button>
							                    </p>
							                  </div>
							                </div>
						              	</a>
									</div>
								</div>
								<div class="mt-3">
									<pagination :collections="videoLibraries" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>

	window.dataLayer = window.dataLayer || [];
	function gtag(){dataLayer.push(arguments);}
	gtag('js', new Date());

	gtag('config', window.gtag_id);

	import { onMounted, watch, ref } from 'vue'
	import AuthLayout from '../../../Layouts/AuthLayout'
	import { Inertia } from '@inertiajs/inertia'

	export default {
		layout: AuthLayout,
		props: {
			tab 			: String,
			category 		: String,
			live_vimeo_id 	: Number,
			liveVideo 		: Object,
			liveSchedules 	: Object,
			featuredVideos 	: Object,
			videoLibraries 	: Object,
			videoCategories : Object,
		},
		created() {

			var _this = this;
			
			setTimeout(function(){ 
                var elem = "";

                if(_this.tab=='library')
                {
                	elem =  document.getElementById('tab_category');
                }else{
                	elem =  document.getElementById('tab_live');	
                }
                elem.click(); 
            }, 1);

	  	},
		setup(props) {

			onMounted(() => {
				const pageContainer = document.getElementById('page-container')
				if (pageContainer.classList.contains('sidebar-o-xs'))
					pageContainer.classList.remove('sidebar-o-xs')
			})

			const modal 			= ref(null);
			const selected_tab 		= ref(props.tab);

			const filter_date 		= ref('all');
			const searching_process = ref(false);

			const selectedVideo = ({});
				
			const selected_category = ref(props.category);

			const selectVideo = (_index,_loc)=>{
									var svideo = "";

									if(_loc=='featured')
									{
										svideo = props.featuredVideos[_index];
									}else{
										svideo = props.videoLibraries.data[_index];
									}
										
									Object.assign(selectedVideo,svideo);
									modal.value.toggleModal(true);
								}

			const getCategory = ()=>{
										selected_category.value = props.category;
										selected_tab.value 		= 'library';
									}

			const getCategoryTitle = (category)=>{

									var title = Object.entries(props.videoCategories).filter((data,key)=>{
										if(data[1][category]!==undefined)
										{
											return data[1][category];
										}
									});
									return title[0][1][category];
								}

			const checkVideoDeniedAccess = (current_rank)=>{
				
											var fstring = (selected_category.value).split("_")[0];

											if(current_rank=='SILVER' && ['gold','diamond','platinum'].includes(fstring))
											{
												return true;
											}else if(current_rank=='GOLD' && ['diamond','platinum'].includes(fstring))
											{
												return true;
											}else if(current_rank=='DIAMOND' && ['platinum'].includes(fstring))
											{
												return true;
											}else
											{
												return false;
											}
										}

			const categories = ()=>{
								return Object.fromEntries(Object.entries(props.videoCategories).filter(([key]) => !key.includes('Course') && !key.includes('Feature')));
							}

			const filterByDate = (_filter_date)=>{
									filter_date.value = _filter_date;
									searching_process.value = true;
									Inertia.get(route('member.trc-live.video-library'),
									{
										tab 		: selected_tab.value,
										category 	: selected_category.value,
										filter_date : _filter_date
									},
									{
										preserveState: true,
										preserveScroll: true,
										only:['videoLibraries'],
										onSuccess:()=>searching_process.value = false
									});
								}


			//START For Zoom Event Countdown
			const countdown_time_left 	= ref(90000);
			const countdown_done 		= ref(false);
			const countdown_display 	= ref('00:00:00');

			if(props.liveVideo.length>0)
			{
				if(props.liveVideo[0].time_left<=86400)
				{
					countdown_time_left.value = props.liveVideo[0].time_left;
					setTimeout(function(){
					    countdown_time_left.value--;
					},1000);
				}

			}
			
			watch(countdown_time_left,(value,old_value)=>{

				var self = this;
				var hrs = 0, mins = 0, secs = 0;
				if (value>0 && value!=old_value) {

					hrs 	= Math.floor(countdown_time_left.value/60/60);
					mins 	= Math.floor(countdown_time_left.value/60);
					secs 	= value;

					secs 	= secs % 60;
					mins 	= mins % 60;
					hrs 	= hrs % 24;

					countdown_display.value = (hrs>9 ? hrs : "0" + hrs) + ":" + (mins>9 ? mins : "0" + mins) + ":" + (secs>9 ? secs : "0" + secs);

					setTimeout(function(){
					    countdown_time_left.value--;
					},1000);

				} else {
					countdown_display.value = "00:00:00";
					countdown_done.value = true;
				}

			})
			//END For Zoom Event Countdown


			watch(selected_category,(value,old_value)=>{

				if(old_value!=value)
				{
					filter_date.value = 'all';
					$("#btn_show_all").click();
					searching_process.value = true;
					Inertia.get(route('member.trc-live.video-library'),
					{
						tab 		: selected_tab.value,
						category 	: selected_category.value
					},
					{
						preserveState: true,
						preserveScroll: true,
						only:['featuredVideos,videoLibraries'],
						onSuccess:()=>searching_process.value = false
					});
				}
			})

			watch(selected_tab,(value,old_value)=>{

				if(old_value!=value)
				{
					Inertia.get(route('member.trc-live.video-library'),
					{
						tab 	: selected_tab.value
					},
					{
						preserveState: true,
						preserveScroll: true,
						only:['liveVideo,liveSchedules,featuredVideos,videoLibraries']
					});
				}
			})


			return{
				modal,
				filter_date,
				searching_process,
				countdown_done,
				countdown_time_left,
				countdown_display,
				selectedVideo,
				selectVideo,
				selected_tab,
				getCategory,
				selected_category,
				getCategoryTitle,
				categories,
				checkVideoDeniedAccess,
				filterByDate
			}
		},
	}
</script>